import CreateTicketsPage from './CreateTicketsPage';

export default CreateTicketsPage;
